import { createStore } from '@xstate/store'

type Context = {
  drawer?: Drawer | null
}

type Drawer = {
  id: 'uploads'
  tab?: 'single_hand' | 'multiple_hand'
}

const context: Context = {
  drawer: null,
}

export const drawersBridge = createStore({
  context,
  emits: {
    drawerOpened: (_payload: { drawer: Drawer }) => {},
    drawerToggled: (_payload: { drawer: Drawer }) => {},
  },
  on: {
    openDrawer: (context, event: { drawer: Drawer }, enqueue) => {
      enqueue.emit.drawerOpened(event)

      return {
        ...context,
        drawer: event.drawer,
      }
    },
    toggleDrawer: (context, event: { drawer: Drawer }, enqueue) => {
      enqueue.emit.drawerToggled(event)

      return {
        ...context,
        drawer: event.drawer,
      }
    },
  },
})
